<template>
  <div
    class="chat-group-member"
    :class="active ? 'active' : ''"
    :style="{ height: height + 'px' }"
  >
    <div class="member-avatar">
      <head-image
        :size="headImageSize"
        :name="member.showNickName"
        :url="member.headImage"
      >
      </head-image>
    </div>
    <div class="member-name" :style="{ 'line-height': height + 'px' }">
      <div>{{ member.showNickName }}</div>
    </div>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
export default {
  name: "groupMember",
  components: { HeadImage },
  data() {
    return {};
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 50,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headImageSize() {
      return Math.ceil(this.height * 0.75);
    },
  },
};
</script>

<style lang="scss">
.chat-group-member {
  display: flex;
  margin-bottom: 1px;
  position: relative;
  padding: 0 5px;
  align-items: center;
  background-color: #fafafa;
  white-space: nowrap;
  box-sizing: border-box;

  &:hover {
    background-color: #f8faff;
  }

  &.active {
    background-color: #e8f2ff;
  }

  .member-name {
    padding-left: 10px;
    height: 100%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    font-weight: 600;
    & > div {
      width: 100%;
      overflow: hidden;
      white-space: nowrap; /*设置不换行*/
      overflow: hidden; /*设置隐藏*/
      text-overflow: ellipsis; /*设置隐藏部分为省略号*/
    }
  }
}
</style>
